import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The entrepreneur's curse",
  "description": "",
  "published": "2011-07-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-entrepreneurs-curse/swizec/1924"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It is the middle of the night. Everyone is asleep. And I just spent ten minutes laying on the concrete floor in the backyard of `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-couldnt-get-into-yc-so-i-joined-a-startup-that-did/swizec/1855"
      }}>{`our house in Palo Alto`}</a>{`. Just looking at the stars.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-University_Avenue_at_the_Circle_with_train_steaming_toward_El_Palo_Alto%2C_1894.jpg",
        "alt": "University Avenue at the Circle with train ste...",
        "title": "University Avenue at the Circle with train ste..."
      }}></img></p>
    <p>{`It felt surprisingly fitting.`}</p>
    <p><em parentName="p">{`tl;dr --> Always seeing ways to improve things and knowing you'll never get to improve them ... sucks.`}</em></p>
    <p>{`I read on some blog once that the marked difference between humans and entrepreneurs is that when a normal person sees something that's a bit off, that doesn't work, or just isn't quite There. They shrug and work around it. They might even complain a little. Let out a curse word or two. But otherwise pretty much get on with their life.`}</p>
    <p>{`An entrepreneur, on the other hand, will go "Hmm, I think I can fix that".`}</p>
    <p>{`What happens when almost every thing you touch is suboptimal? When whatever you happen to be doing, feels like it could be done better? What then?`}</p>
    <p>{`In a couple of months I will be 24 years old. I will not have solved any significant problem. I've seen many, but I simply won't have solved any. The thing with time and aging is that you can only do so much. You have to pick. Even if you see many things that `}<em parentName="p">{`need`}</em>{` to be improved; and you can fix a small subset of them. You still have to pick.`}</p>
    <p>{`Time is a bitch like that.`}</p>
    <p>{`I can swallow the fact that because I have Better Things (tm) to do I will likely never go to all the best parties, see all the best clubs and go to all the best concerts. I will never get to wake up with my head in Janis Joplin's lap. I will `}{`[`}{`likely] never have quite solved that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/doing-a-startup-taught-me-the-value-of-staying-in-school/swizec/1819"
      }}>{`information overload problem I was working on`}</a>{` that one time ...`}</p>
    <p>{`There is a popular saying on 4chan "Regret nothing. At one point it was exactly what you wanted."`}</p>
    <p>{`A brilliant quote to keep us reminded that life is pretty much at our mercy. Not the other way around.`}</p>
    <p>{`Then again, what if "it" isn't exactly what you wanted? Maybe it's just the most achievable option. Or it might be a bitter step on your path to what you want etc. Maybe you had ten options and simply had to pick one. Or maybe you're just a farmer somewhere in Africa and no matter what you want, circumstance has made the choices for you.`}</p>
    <p>{`I'm raising a lot of questions here ... the point I'm getting at is that having a sort of entrepreneurial mindset can be/is a total drag. Always seeing ways to improve things and knowing you'll never get to improve them ... sucks.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.constantcontact.com/commentary/for-entrepreneurs-theres-a-fine-line-between-good-and-bad/"
        }}>{`For Entrepreneurs, There's a Fine Line Between Good and Bad`}</a>{` (blogs.constantcontact.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.icemanbaldy.com/icemanbaldy/2011/05/seven-types-of-entrepreneurs-seven-sins-of-entrepreneurship.html"
        }}>{`Seven Types of Entrepreneurs, Seven Sins of Entrepreneurship`}</a>{` (icemanbaldy.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://owengreaves.com/the-curse-of-the-entrepreneur/"
        }}>{`The Curse Of The Entrepreneur`}</a>{` (owengreaves.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seattletimes.nwsource.com/html/businesstechnology/2015570849_siliconstatus11.html?syndication=rss"
        }}>{`Young tech millionaires keeping 1-bedroom lifestyle`}</a>{` (seattletimes.nwsource.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fed1fdc3-0f11-436a-bf85-0fedbf9618f8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      